export enum Events {
  APPLICATION_PRE_RUN = 'applicationPreRun',
  APPLICATION_POST_RUN = 'applicationPostRun',
  APPLICATION_PRE_INIT = 'applicationPreInit',
  APPLICATION_POST_INIT = 'applicationPostInit',

  AD_SET_PRE_RESOLVE = 'adSetPreResolve',
  AD_SET_POST_RESOLVE = 'adSetPostResolve',
  AD_SET_PRE_RENDER = 'adSetPreRender',
  AD_SET_POST_RENDER = 'adSetPostRender',

  AD_SLOT_PRE_RENDER = 'adSlotPreRender',
  AD_SLOT_POST_RENDER = 'adSlotPostRender',

  AD_SLOT_CONTAINER_NO_ITEMS = 'adSlotContainerNoItems',
  AD_SLOT_CONTAINER_NOT_FOUND = 'adSlotContainerNotFound',
  AD_SLOT_CONTAINER_PRE_RENDER = 'adSlotContainerPreRender',
  AD_SLOT_CONTAINER_POST_RENDER = 'adSlotElementPostRender',

  NPI_PRE_DETECT = 'npiPreDetect',
  NPI_POST_DETECT = 'npiPostDetect',

  INTEGRATION_PRE_RUN = 'integrationPreRun',
  INTEGRATION_POST_RUN = 'integrationPostRun',

  BACKEND_EVENT = 'backendEvent',
  TELEMETRY_EVENT = 'telemetryEvent',

  AD_SLOT_CONTAINER_ITEM_VIEW = 'adSlotContainerItemView',
  AD_SLOT_CONTAINER_VIEW = 'adSlotContainerView',
}
